import { createContext, type ReactNode } from "react";

export type AdGroupDraftValidationContextValue = {
	reportHeadlineDraftBlocking: (fieldId: string, blocking: boolean) => void;
	reportDescriptionDraftBlocking: (fieldId: string, blocking: boolean) => void;
};

export const AdGroupDraftValidationContext =
	createContext<AdGroupDraftValidationContextValue | null>(null);

export function AdGroupDraftValidationProvider({
	children,
	value,
}: {
	children: ReactNode;
	value: AdGroupDraftValidationContextValue;
}) {
	return (
		<AdGroupDraftValidationContext.Provider value={value}>
			{children}
		</AdGroupDraftValidationContext.Provider>
	);
}
